import { ApiError, beablooApi } from '../../utils';

const setIntrested = () => {
  return async (dispatch, getState) => {
    const { general } = getState();

    const response = await beablooApi({
      method: 'GET',
      route: `/developments/${general.currentDevelopment.id}/pages/registerinterest`,
    })
      .then((r) => r.data)
      .catch((e) => {
        throw new ApiError('failed to get interested', []);
      });

    dispatch({
      type: 'SET_INTERESTED',
      data: response,
    });
  };
};

export { setIntrested };
